import { Box, Button, styled } from "@mui/material";
import { useModal } from "@landingClient/hooks/useModal";
import { AuthTab, ModalType } from "@landingClient/store/modalSlice";
import { Button as RoundButton } from "@uicomponents/ui/button";
import { useNavigate } from "@tanstack/react-router";

const BlackTextButton = styled(Button)({
  color: "black",
  textTransform: "none",
  fontSize: "1rem",
  "&:hover": {
    color: "black",
    backgroundColor: "transparent",
  },
});

const LoginButton = () => {
  const navigate = useNavigate();
  const { openModal } = useModal();

  const handleLoginClick = () => {
    openModal(ModalType.Auth, { defaultTab: AuthTab.Login });
  };

  return (
    <Box display="flex" flexDirection={{ xs: "column", sm: "row" }} gap={2}>
      <BlackTextButton
        onClick={handleLoginClick}
        variant="text"
        className="font-medium border-primary/20 hover:bg-primary/5 hover:text-primary"
        data-testid="button-login"
      >
        Log in
      </BlackTextButton>
      <RoundButton
        onClick={() => {
          navigate({
            to: "/",
            hash: "contact",
          });
        }}
        style={{ cursor: "pointer" }}
        className="w-full px-6 justify-center text-sm rounded-full bg-primary text-white shadow-lg shadow-primary/25"
      >
        Get Started
      </RoundButton>
    </Box>
  );
};

export default LoginButton;
